export default __webpack_public_path__ + "static/media/Nesha_Laser_0013_Laser_6.030ab053.png";